<template>
  <el-button size="mini" type="danger" plain @click="onSubmit">
    Delete
  </el-button>
</template>

<script>
export default {
  props: {
    brandId: {
      required: true,
      type: String,
    },
  },

  methods: {
    async onSubmit() {
      try {
        await this.$confirm('The brand will be permanently removed.', 'Confirm Delete', {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
      } catch(err) {
        return false
      }

      try {
        var { data } = await this.$http.delete(`/brands/${ this.brandId }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.$emit('delete')
      this.$message.success(data.message)
    },
  },
}
</script>
